export const dateJsonSchema = {
  type: 'object',
  properties: {
    eventName: {
      type: 'string',
    },
    storeSelector: {
      type: 'string',
    },
  },
}

export const dateUiSchema = {
  type: 'HorizontalLayout',
  className: 'review-bulk-filters',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/eventName',
      component: 'ReadOnlyFieldWithJson',
      label: 'Event Name',
    },
    {
      type: 'Control',
      scope: '#/properties/storeSelector',
      component: 'ReadOnlyFieldWithJson',
      label: 'Store Selector',
    },
  ],
}

export const rulesJsonSchema = {
  type: 'object',
  properties: {
    action: {
      type: 'string',
    },
    numberOfPoints: {
      type: 'number',
    },
  },
}

export const rulesJsonSchemaForDays = {
  type: 'object',
  properties: {
    action: {
      type: 'string',
    },
    numberOfDays: {
      type: 'number',
    },
  },
}

export const rulesUiSchemaForDays = {
  type: 'HorizontalLayout',
  className: 'review-bulk-filters',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/action',
      component: 'ReadOnlyFieldWithJson',
      label: 'Action',
    },
    {
      type: 'Control',
      scope: '#/properties/numberOfDays',
      component: 'ReadOnlyFieldWithJson',
      label: 'Number of Days',
    },
  ],
}

export const rulesUiSchema = {
  type: 'HorizontalLayout',
  className: 'review-bulk-filters',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/action',
      component: 'ReadOnlyFieldWithJson',
      label: 'Action',
    },
    {
      type: 'Control',
      scope: '#/properties/numberOfPoints',
      component: 'ReadOnlyFieldWithJson',
      label: 'Number of Points',
    },
  ],
}

export const availJsonSchema = {
  type: 'object',
  properties: {
    schedule: {
      type: 'string',
    },
    date: {
      type: 'number',
    },
  },
}

export const availUiSchema = {
  type: 'HorizontalLayout',
  className: 'review-bulk-filters',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/schedule',
      component: 'ReadOnlyFieldWithJson',
      label: 'Schedule',
    },
    {
      type: 'Control',
      scope: '#/properties/date',
      component: 'ReadOnlyFieldWithJson',
      label: 'Date',
    },
  ],
}

export const fileJsonSchema = {
  type: 'object',
  properties: {
    template: {
      type: 'string',
    },
  },
}

export const fileUiSchema = {
  type: 'HorizontalLayout',
  className: 'review-bulk-filters review_file_color',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/template',
      component: 'ReadOnlyFieldWithJson',
      label: 'Template',
    },
  ],
}
